export default "__VITE_ASSET__DCY85JeG__"